/* Adapt PDP "Meet Dew." section (2026-10-05). Crossfading product stage with tabs (auto-plays once, stops on any touch), swipe support, closing line that lights up word by word. No scroll listeners, nothing here changes element sizes. Loaded with defer by sections/pdp-image-trio.liquid. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-md]').forEach(function(root){
    root.classList.add('has-js');

    function onView(el, cb, th){
      if(!el) return;
      if(!('IntersectionObserver' in window)){ cb(); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ io.disconnect(); cb(); }
        });
      }, { threshold: th || 0.3 });
      io.observe(el);
    }

    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-md-img]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-md-tab]'));
    var lines = Array.prototype.slice.call(root.querySelectorAll('[data-md-line]'));
    var vp = root.querySelector('[data-md-viewport]');
    var cur = 0, timer = null, user = false;

    function show(n){
      cur = n;
      imgs.forEach(function(im, i){ im.classList.toggle('is-on', i === n); });
      lines.forEach(function(l, i){ l.classList.toggle('is-on', i === n); });
      tabs.forEach(function(t, i){
        var on = i === n;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function stopAuto(){
      user = true;
      clearTimeout(timer);
      tabs.forEach(function(t){ t.classList.remove('is-auto'); });
    }
    function step(){
      tabs[cur].classList.add('is-auto');
      timer = setTimeout(function(){
        if(user) return;
        tabs[cur].classList.remove('is-auto');
        if(cur < tabs.length - 1){ show(cur + 1); step(); }
      }, 4200);
    }

    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ stopAuto(); show(i); });
    });

    if(vp){
      var x0 = null;
      vp.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      vp.addEventListener('touchend', function(e){
        if(x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if(Math.abs(dx) > 40){
          stopAuto();
          show(Math.max(0, Math.min(tabs.length - 1, cur + (dx < 0 ? 1 : -1))));
        }
      }, { passive: true });
    }

    if(tabs.length){
      show(0);
      if(!reduce && vp) onView(vp, step, 0.5);
    }

    var close = root.querySelector('[data-md-close]');
    if(close){
      onView(close, function(){ close.classList.add('is-in'); }, 0.5);
      setTimeout(function(){ close.classList.add('is-in'); }, 8000);
    }
  });
})();